import React from 'react';
import { observer } from 'mobx-react';
import { TeamMemberStore } from '@seedlang/stores';
import TeamMemberCreate from 'pages/builder/team_members/team_member_create';
import { Link } from 'react-router';
import autobind from 'autobind-decorator';
import DeleteButton from 'components/button/delete_button';
import InPlaceCheckbox from 'components/form/in_place_checkbox';
import InPlaceText from 'components/form/in_place_text';
import Spinner from 'components/spinner';

@observer
class TeamMemberIndex extends React.Component {

  componentDidMount() {
    this.getTeamMembers();
  }

  @autobind getTeamMembers() {
    TeamMemberStore.getIndex();
  }

  @autobind onDelete(id) {
    TeamMemberStore.destroy({ids: {teamMemberId: id}}, this.getTeamMembers);
  }

  render() {
    if (TeamMemberStore.hasOutstandingRequests) {
      return <Spinner />;
    }

    return (
      <div className='team-member-builder-index'>
        <TeamMemberCreate />
        <table className='table-wrapper admin-table'>
          <thead>
            <tr>
              <th width='40' />
              <th>Position</th>
              <th>Name</th>
              <th>Title</th>
              <th>Active</th>
              <th width='40'></th>
            </tr>
          </thead>
          <tbody>
            {
              TeamMemberStore.indexData.map(item => {
                return (
                  <tr key={item.id}>
                    <td>
                      <Link
                        to={{ name: 'builder.team_members.edit', params: { teamMemberId: item.id } }}
                        className='on-click'
                      >
                        <i className='fa fa-chevron-right fa-block' />
                      </Link>
                    </td>
                    <td>
                      <InPlaceText
                        id={item.id}
                        defaultValue={item.position}
                        model='team_members'
                        field='position'
                        afterChange={this.getTeamMembers}
                      />
                    </td>
                    <td>
                      {item.name}
                    </td>
                    <td>
                      {item.title}
                    </td>
                    <td>
                      <InPlaceCheckbox
                        id={item.id}
                        value={item.active}
                        model='team_members'
                        field='active'
                      />
                    </td>
                    <td>
                      <DeleteButton
                        onConfirm={() => this.onDelete(item.id)}
                        message='Delete this team member?'
                        className='fa-block right'
                      />
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
      </div>
    );
  }
}

export default TeamMemberIndex;